import PropTypes from 'prop-types';

import LanguageModel from './Language';
import OgTagsModel from './OgTags';
import PageLinkModel from './PageLink';
import ProcessStepModel from './ProcessStep';
import ProjectModel from './Project';

export default {
  id: PropTypes.number.isRequired,
  language: PropTypes.shape(LanguageModel).isRequired,
  ogTags: PropTypes.shape(OgTagsModel).isRequired,
  navLinks: PropTypes.arrayOf(PropTypes.shape(PageLinkModel)).isRequired,
  heading: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  article1Heading: PropTypes.string.isRequired,
  article1Text: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape(ProcessStepModel)).isRequired,
  article2Text: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  project: PropTypes.shape(ProjectModel).isRequired,
  footerLinkPrev: PropTypes.shape(PageLinkModel).isRequired,
  footerLinkNext: PropTypes.shape(PageLinkModel).isRequired,
};
